{
  "Earlier": "較早",
  "noAnnouncements": "您會收到預定維護活動和產品問題修正的相關資訊",
  "noAnnouncementsTitle": "公告會顯示於此處"
}
